import { render, staticRenderFns } from "./ProjectAssociatedEntitiesTab.vue?vue&type=template&id=5c6ca07a&scoped=true"
import script from "./ProjectAssociatedEntitiesTab.vue?vue&type=script&lang=js"
export * from "./ProjectAssociatedEntitiesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6ca07a",
  null
  
)

export default component.exports